<div [formGroup]="filterGroup" class="d-flex flex-row align-items-center">
  <ng-select
    class="w-100 mr-2"
    formControlName="column"
    [items]="columnFilters"
    bindLabel="columnName"
    placeholder="Select a column"
    clearAllText="Clear"
    [clearable]="true"
    [required]="false"
    [closeOnSelect]="false"
  >
    <ng-template ng-option-tmp let-item="item">
      <div
        [ngbTooltip]="item != null ? item.columnName : ''"
        container="body"
        class="ellipsis"
      >
        {{ item !== null ? item.columnName : '' }}
      </div>
    </ng-template>
  </ng-select>

  <!-- Optional host-projected control, rendered between the column and the operator. Selector-scoped
       rather than a bare <ng-content>: only a node explicitly marked `columnTypeSlot` lands here, so
       a host cannot accidentally project stray content (whitespace, a comment, a future child
       element) into the middle of this row. Empty — and therefore invisible — for every existing
       consumer, none of which project anything. positions-2 projects the AGGREGATE_INFO
       comparison-type picker here: it has to sit BEFORE the operator, because the chosen type
       re-derives which operators are offered. -->
  <ng-content select="[columnTypeSlot]"></ng-content>

  <ng-select
    class="w-100 mr-2"
    formControlName="operator"
    [items]="availableOperators"
    bindLabel="name"
    placeholder="Select an operator"
    clearAllText="Clear"
    [clearable]="true"
    [required]="false"
    [closeOnSelect]="false"
  >
    <ng-template ng-option-tmp let-item="item">
      <div
        [ngbTooltip]="item != null ? item.name : ''"
        container="body"
        class="ellipsis"
      >
        {{ item !== null ? item.name : '' }}
      </div>
    </ng-template>
  </ng-select>

  <div
    class="w-100"
    formGroupName="valueGroup"
    [ngSwitch]="filterValueInputType"
  >
    <input
      *ngSwitchCase="'textInput'"
      class="w-100 p-1"
      formControlName="filterValue"
      type="text"
      placeholder="Enter a value"
    />
    <nf-form-control *ngSwitchCase="'identifierInput'" class="mb-0" compact>
      <nf-number
        class="w-100"
        formControlName="filterValue"
        type="text"
        placeholder="Enter an ID"
        [formatOptions]="{
          groupSeparator: ''
        }"
      ></nf-number>
    </nf-form-control>
    <input
      *ngSwitchCase="'identifierInInput'"
      class="w-100 p-1"
      formControlName="filterValue"
      type="text"
      placeholder="filter list (comma separated)"
    />
    <div
      *ngSwitchCase="'identifierRangeInput'"
      class="d-flex flex-row w-100 p-1"
    >
      <nf-form-control class="mr-2 mb-0" label="From" for="filterFrom">
        <nf-number
          id="filterFrom"
          class="w-100"
          formControlName="filterValue"
          type="text"
          placeholder="Enter an ID"
          [formatOptions]="{
            groupSeparator: ''
          }"
        ></nf-number>
      </nf-form-control>
      <nf-form-control class="mb-0" label="To" for="filterTo">
        <nf-number
          id="filterTo"
          class="w-100"
          formControlName="filterToValue"
          type="text"
          placeholder="Enter an ID"
          [formatOptions]="{
            groupSeparator: ''
          }"
        ></nf-number>
      </nf-form-control>
    </div>
    <nf-form-control *ngSwitchCase="'numberInput'" class="mb-0" compact>
      <nf-number
        class="w-100"
        formControlName="filterValue"
        type="text"
        placeholder="Enter a number"
      >
      </nf-number>
    </nf-form-control>
    <input
      *ngSwitchCase="'numberInInput'"
      class="w-100 p-1"
      formControlName="filterValue"
      type="text"
      placeholder="filter list (comma separated)"
    />
    <div *ngSwitchCase="'numberRangeInput'" class="d-flex flex-row w-100 p-1">
      <nf-form-control class="mr-2 mb-0" label="From" for="filterFrom">
        <nf-number
          id="filterFrom"
          class="w-100"
          formControlName="filterValue"
          type="text"
          placeholder="Enter number"
        ></nf-number>
      </nf-form-control>
      <nf-form-control class="mb-0" label="To" for="filterTo">
        <nf-number
          id="filterTo"
          class="w-100"
          formControlName="filterToValue"
          type="text"
          placeholder="Enter number"
        ></nf-number>
      </nf-form-control>
    </div>
    <ng-select
      *ngSwitchCase="'multiSelector'"
      class="w-100 multi-select-padding"
      formControlName="filterValue"
      [multiple]="true"
      [closeOnSelect]="false"
      [items]="setFilterOptions | async"
      bindLabel="key"
      placeholder="Select a value"
      clearAllText="Clear"
      [clearable]="true"
      [virtualScroll]="true"
    >
      <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
        <div
          *ngIf="items.length > 1; else singleItem"
          class="ng-value nf-custom-badge"
        >
          <span class="ng-value-label">
            {{ items.length }} items selected
          </span>
        </div>
        <ng-template #singleItem>
          <div class="ng-value nf-custom-badge">
            <span
              class="ng-value-label"
              [innerHTML]="items[0].cellRenderer()"
            ></span>
          </div>
        </ng-template>
      </ng-template>

      <ng-template
        ng-option-tmp
        let-item="item"
        let-index="index"
        let-item$="item$"
      >
        <div class="select-option" compact>
          <input
            id="item-{{ index }}"
            type="checkbox"
            [ngModel]="item$.selected"
            [ngModelOptions]="{ standalone: true }"
            class="select-option-checkbox"
          />
          <span
            [ngbTooltip]="item.key"
            container="body"
            class="ellipsis"
            [innerHTML]="item.cellRenderer()"
          ></span>
        </div>
      </ng-template>
    </ng-select>
    <div *ngSwitchCase="'none'"></div>
    <nf-datepicker
      *ngSwitchCase="'datePicker'"
      class="w-100 p-1"
      formControlName="filterValue"
      [format]="displayDateFormat"
    >
    </nf-datepicker>
    <nf-time-picker
      *ngSwitchCase="'timePicker'"
      class="form-control w-100 p-1"
      style="min-width: 160px"
      formControlName="filterValue"
    >
    </nf-time-picker>
    <nf-date-time-picker
      *ngSwitchCase="'dateTimePicker'"
      class="form-control w-100 p-1"
      formControlName="filterValue"
    >
    </nf-date-time-picker>
    <div *ngSwitchCase="'dateRange'" class="d-flex flex-row w-100 p-1">
      <nf-form-control class="mr-2 mb-0" label="Begin" for="filterBegin">
        <nf-datepicker
          id="filterBegin"
          class="w-100"
          formControlName="filterValue"
          [format]="displayDateFormat"
        >
        </nf-datepicker>
      </nf-form-control>
      <nf-form-control class="mb-0" label="End" for="filterEnd">
        <nf-datepicker
          id="filterEnd"
          class="w-100"
          formControlName="filterToValue"
          [format]="displayDateFormat"
        >
        </nf-datepicker>
      </nf-form-control>
    </div>
    <div *ngSwitchCase="'timeRange'" class="d-flex flex-row w-100 p-1">
      <nf-form-control class="w-50 mr-2 mb-0" label="Begin" for="filterBegin">
        <nf-time-picker
          id="filterBegin"
          formControlName="filterValue"
          class="form-control"
          style="min-width: 160px"
        >
        </nf-time-picker>
      </nf-form-control>
      <nf-form-control class="w-50 mb-0" label="End" for="filterEnd">
        <nf-time-picker
          id="filterEnd"
          formControlName="filterToValue"
          class="form-control"
          style="min-width: 160px"
        >
        </nf-time-picker>
      </nf-form-control>
    </div>
    <div *ngSwitchCase="'dateTimeRange'" class="d-flex flex-row w-100 p-1">
      <nf-form-control class="mr-2 mb-0" label="Begin" for="filterBegin">
        <nf-date-time-picker
          id="filterBegin"
          class="form-control w-100"
          formControlName="filterValue"
        ></nf-date-time-picker>
      </nf-form-control>
      <nf-form-control class="mb-0" label="End" for="filterEnd">
        <nf-date-time-picker
          id="filterEnd"
          class="form-control w-100 mr-2"
          formControlName="filterToValue"
        ></nf-date-time-picker>
      </nf-form-control>
    </div>
    <input
      *ngSwitchDefault
      class="w-100 p-1"
      formControlName="filterValue"
      type="text"
      placeholder="Value to filter"
    />
  </div>
</div>
